if (!window.Eurus.loadedScript.has('variant-links.js')) {
  window.Eurus.loadedScript.add('variant-links.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      initVariantOptions();
    });
  });

  /**
   * Map product options and link the product's swatches to its corresponding product URL.
   */
  const initVariantOptions = () => {
    const productOptionsData = document.getElementById('product-options');
    const allOptionsData = document.getElementById('variant-options');
    const allVariantSwatches = document.querySelectorAll(
      '.product-info .swatch-element',
    );

    if (!productOptionsData || !allOptionsData || !allVariantSwatches.length) {
      return;
    }

    const findBestProductOption = (
      productOptions,
      allOptions,
      currentOption,
    ) => {
      // Find the complementary option key & value from productOptions.
      const complementaryKey = Object.keys(productOptions).find(
        (key) => key !== currentOption.key,
      );
      const complementaryValue = productOptions[complementaryKey];

      // Try to find an exact match for both options.
      const exactMatch = allOptions.find(
        (variant) =>
          variant[currentOption.key] === currentOption.value &&
          variant[complementaryKey] === complementaryValue,
      );
      if (exactMatch) {
        return exactMatch.url;
      }

      // If no exact match is found then use a partial match where only the selected option matches.
      const partialMatch = allOptions.find(
        (variant) => variant[currentOption.key] === currentOption.value,
      );
      if (partialMatch) {
        return partialMatch.url;
      }

      // If no match at all, check for the first variant that contains the complementary value.
      const fallbackMatch = allOptions.find(
        (variant) => variant[complementaryKey] === complementaryValue,
      );
      if (fallbackMatch) {
        return fallbackMatch.url;
      }

      // Return the first available variant if all else fails.
      return allOptions.length > 0 ? allOptions[0].url : null;
    };

    try {
      const productOptions = JSON.parse(productOptionsData.textContent);
      const allOptions = JSON.parse(allOptionsData.textContent);

      allVariantSwatches.forEach((swatch) => {
        // Assign each product option/swatch its corresponding URL.
        const { key, value } = swatch.dataset;
        const bestUrl = findBestProductOption(productOptions, allOptions, {
          key,
          value,
        });

        if (!bestUrl) {
          console.error(`Failed to find a matching product option.`);
          swatch.setAttribute('href', '#');
          swatch.classList.add('unavailable');
        } else {
          swatch.setAttribute('href', bestUrl);
        }

        // A swatch is also 'unavailable' if the second option (e.g., Flavor) doesn't have a corresponding first option (e.g., Size).
        if (key !== Object.keys(productOptions)[0]) {
          const primaryOptionKey = Object.keys(productOptions)[0];
          const primaryOptionValue = productOptions[primaryOptionKey];

          const isValid = allOptions.some(
            (variant) =>
              variant[key] === value &&
              variant[primaryOptionKey] === primaryOptionValue,
          );

          if (!isValid) {
            swatch.classList.add('unavailable');
          }
        }
      });
    } catch (error) {
      console.error('Failed to parse variant options data:', error);
    }
  };
}
